import React from 'react';
import { CheckCircle } from 'lucide-react';
import { ACCENTS, Icon } from './theme';

export const ProductOverview = ({ product }) => {
  const { overview, accent } = product;
  const t = ACCENTS[accent];
  return (
    <section className="py-20 px-6 lg:px-12">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <span className={`${t.label} font-semibold uppercase tracking-wide text-sm`}>Product Overview</span>
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mt-2 mb-4">{overview.heading}</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">{overview.sub}</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-6">{overview.checklistTitle}</h3>
            <div className="space-y-4">
              {overview.checklist.map((item) => (
                <div key={item} className="flex items-start gap-3">
                  <CheckCircle className={`w-6 h-6 ${t.check} flex-shrink-0 mt-0.5`} />
                  <p className="text-gray-700">{item}</p>
                </div>
              ))}
            </div>
          </div>

          <div className={`bg-gradient-to-br ${overview.panelGradient} p-8 rounded-2xl`}>
            <h4 className="text-xl font-bold text-gray-900 mb-6">Why {product.name} Stands Out</h4>
            <div className="grid grid-cols-2 gap-4">
              {overview.stats.map((stat) => (
                <div key={stat.label} className="bg-white p-4 rounded-xl shadow-sm text-center">
                  <p className={`text-2xl font-bold ${t.stat}`}>{stat.value}</p>
                  <p className="text-sm text-gray-500">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export const FeatureGrid = ({ product }) => {
  const { features, accent } = product;
  const t = ACCENTS[accent];
  return (
    <section className="py-20 px-6 lg:px-12 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <span className={`${t.label} font-semibold uppercase tracking-wide text-sm`}>Key Features</span>
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mt-2 mb-4">{features.heading}</h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.items.map((feature) => (
            <div key={feature.title} className="bg-white p-6 rounded-2xl shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-100 group">
              <div className={`${t.featureIconBox} w-14 h-14 rounded-xl flex items-center justify-center mb-4 transition-colors`}>
                <Icon name={feature.icon} className={`w-7 h-7 ${t.featureIcon} transition-colors`} />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{feature.title}</h3>
              <p className="text-gray-600 text-sm">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
